import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'customDate',
    standalone: false
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
    override transform(value: string, format?: string, args?: any): any {
        if (format === 'long') {
            return super.transform(value, 'dd-MMM-yyyy, hh:mm:ss aa (zzz)', args);
        }
        return super.transform(value, 'dd-MMM-yy HH:mm:ss', args);
    }
}
